import Vue from 'vue';

import VeeValidate, { Validator } from 'vee-validate';
const config = {
  aria: true,
  classNames: {},
  classes: false,
  delay: 0,
  dictionary: null,
  errorBagName: 'errors', // change if property conflicts
  events: 'input|blur',
  fieldsBagName: 'fieldName',
  i18n: null, // the vue-i18n plugin instance
  i18nRootKey: 'validations', // the nested key under which the validation messages will be located
  inject: true,
  locale: 'en',
  validity: false,
  useConstraintAttrs: true,
  max: (event: string, args: any[]) => `最多只能填写${args[0]}个字符`,
  min: (event: string, args: any[]) => `最少需要填写${args[0]}个字符`
};
// 手机号验证
Validator.extend('mobile', {
  validate: (value) => {
    return (
      value.length == 11 &&
      /^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/.test(
        value
      )
    );
  }
});
//大陆身份证验证
Validator.extend('idCard', {
  validate: (value) => {
    const patternMainLand = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|x|X)$/; //大陆
    return patternMainLand.test(value);
  }
});
// 港澳台大陆身份证验证
Validator.extend('allCard', {
  validate: (value) => {
    const patternMainLand = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|x|X)$/; //大陆
    const patternHongkong = /^[A-Z]{1,2}[0-9]{6,10}[0-9A-Z]$/; //香港
    const patternTaiwan = /^[a-zA-Z][0-9]{9}$/; //台湾
    const patternMacao = /^[1|5|7][0-9]{6}[0-9A-Z]$/; // 澳门
    return (
      patternMainLand.test(value) ||
      patternHongkong.test(value) ||
      patternTaiwan.test(value) ||
      patternMacao.test(value)
    );
  }
});

Vue.use(VeeValidate, config);
